import regularWoff from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-regular.woff';
import regularWoff2 from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-regular.woff2';
import boldWoff from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-600.woff';
import boldWoff2 from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-600.woff2';
import italicWoff from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-italic.woff';
import italicWoff2 from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-italic.woff2';
import italicBoldWoff from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-600italic.woff';
import italicBoldWoff2 from 'ha/fonts/source-sans-pro-v19-latin_cyrillic-600italic.woff2';

import { FontInfo } from 'ha/components/LoadFonts';

const fontName = 'Source Sans Pro';

const defaultFont: FontInfo = {
  fontName,
  fontFamily: `'${fontName}', 'Helvetica', 'Arial', 'sans-serif'`,
  preloadWoff2Files: [regularWoff2, boldWoff2],
  stage1Files: [
    {
      src: `local('Source Sans Pro Regular'), local('SourceSansPro-Regular'), url('${regularWoff2}') format('woff2'), url('${regularWoff}') format('woff')`,
      options: {
        weight: '400',
        style: 'normal',
        display: 'swap',
      },
    },
    {
      src: `local('Source Sans Pro SemiBold'), local('SourceSansPro-SemiBold'), url('${boldWoff2}') format('woff2'), url('${boldWoff}') format('woff')`,
      options: {
        weight: '600',
        style: 'normal',
        display: 'swap',
      },
    },
  ],
  stage2Files: [
    {
      src: `local('Source Sans Pro Italic'), local('SourceSansPro-Italic'), url('${italicWoff2}') format('woff2'), url('${italicWoff}') format('woff')`,
      options: { style: 'italic' },
    },
    {
      src: `local('Source Sans Pro SemiBold Italic'), local('SourceSansPro-SemiBoldItalic'), url('${italicBoldWoff2}') format('woff2'), url('${italicBoldWoff}') format('woff')`,
      options: { style: 'italic', weight: '600' },
    },
  ],
};

export { defaultFont };
